import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import "./../Content-Library/AddContentModal";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";

const EditResources = ({ isOpen, onClose, id, stepIndex, resourceIndex, defaultTitle, defaultLink, setFetchProgress }) => {
  const [title, setTitle] = useState(defaultTitle);
  const [resourceLink, setResourceLink] = useState(defaultLink);

  useEffect(() => {
    setTitle(defaultTitle);
    setResourceLink(defaultLink);
  }, [defaultTitle, defaultLink, isOpen]);

  const handleUpdateLink = async () => {
    if (!title || !resourceLink) {
      toastr.error("Please fill in all fields");
      throw new Error("Please fill in all fields");
    }

    const payload = {
      title,
      resourceLink,
      id,
      stepIndex,
      resourceIndex
    };

    try {
      const response = await apiServiceHandler("PATCH", "api/courses/steps/resources", { ...payload });
      if (response.auth) {
        toastr.success(response.message);
        setFetchProgress(true);
        onClose();
      } else {
        toastr.error(response.message || "Failed to update the link. Please try again.");
      }
    } catch (error) {
      toastr.error(error.response?.data?.message || "An error occurred");
      console.error(error.response);
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>Edit Resource</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invite-form__fields">
          <div className="invite-form__field">
            <div className="text-input__label">Title</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
          </div>
          <div className="invite-form__field">
            <div className="text-input__label">Resource Link</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                value={resourceLink}
                onChange={(e) => setResourceLink(e.target.value)}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: '1rem' }}>
        <button className="send-invite__btn" onClick={handleUpdateLink}>
          <span className="send-invite-button__label">Update Resource</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditResources;
